<div class="container mx-auto mt-4">
  <div class="card d-print-none">
    <div class="card-body">
      <h3>Consultar PQR por Codigo</h3>
      <form (ngSubmit)="handleSearch()">
        <div class="form-group">
          <label>Codigo de Radicacion</label>
          <input
            type="text"
            class="form-control"
            [formControl]="codeControl"
            [ngClass]="{
              'is-valid': codeControl.touched && codeControl.valid,
              'is-invalid': codeControl.touched && !codeControl.valid
            }"
          />
          <div
            *ngIf="codeControl.touched && !codeControl.valid"
            class="invalid-feedback"
          >
            El codigo es requerido
          </div>
        </div>
        <div class="form-group">
          <re-captcha
            [formControl]="recaptcha"
            name="captcha"
            required
            siteKey="6Lc4ptYZAAAAAFiuTq4rQysS1q3ocGSr_BoGoHuY"
          ></re-captcha>
        </div>
        <div
          *ngIf="recaptcha.touched && !recaptcha.valid"
          class="invalid-feedback"
        >
          Porfavor llene el captcha
        </div>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!codeControl.valid || !recaptcha.valid || isLoading"
        >
          <span
            *ngIf="isLoading"
            class="spinner-border spinner-border-sm mr-1"
          ></span>
          Buscar
        </button>
      </form>
    </div>
  </div>

  <div class="card mt-4" *ngIf="pqrResult">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Resultado de la consulta</h5>
      <button
        *ngIf="pqrResult.response"
        class="btn btn-success btn-sm d-print-none"
        (click)="printPage()"
      >
        <span class="mr-1">&#128424;</span>
        Imprimir
      </button>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6 mb-3">
          <strong>Codigo:</strong>
          <p>{{ pqrResult.code }}</p>
        </div>
        <div class="col-md-6 mb-3">
          <strong>Tipo:</strong>
          <p>{{ pqrResult.translated_kind }}</p>
        </div>
        <div class="col-md-6 mb-3">
          <strong>Motivo:</strong>
          <p>{{ pqrResult.translated_reason }}</p>
        </div>
        <div class="col-md-6 mb-3">
          <strong>Estado:</strong>
          <p>
            <span
              class="badge"
              [ngClass]="{
                'badge-success': pqrResult.status === 'closed',
                'badge-warning': pqrResult.status === 'in_progress',
                'badge-info': pqrResult.status === 'open'
              }"
            >
              {{ pqrResult.translated_status }}
            </span>
          </p>
        </div>
        
        <div class="col-12 mt-3" *ngIf="pqrResult.pqr_messages && pqrResult.pqr_messages.length > 0; else fallbackContent">
          <strong>Historial:</strong>
          <div class="list-group mt-2">
            <div *ngFor="let message of pqrResult.pqr_messages" class="list-group-item flex-column align-items-start mb-3 rounded border shadow-sm">
              <div class="d-flex w-100 justify-content-between mb-2">
                <h6 class="mb-1 text-primary">
                  <ng-container *ngIf="message.sender_type === 'Client'; else advisorHeader">
                    <strong>{{ message.sender_name }}</strong> <small class="text-muted">(Cliente)</small>
                  </ng-container>
                  <ng-template #advisorHeader>
                    <strong>Asesor</strong>
                  </ng-template>
                </h6>
                <small class="text-secondary font-weight-bold">{{ message.created_at | date: 'dd/MM/yyyy hh:mm a' : '-0500' }}</small>
              </div>
              <div [innerHTML]="message.body" class="mb-1 text-dark" style="white-space: pre-line; line-height: 1.5;"></div>
            </div>
          </div>
        </div>

        <ng-template #fallbackContent>
          <div class="col-12 mb-3">
            <strong>Descripcion:</strong>
            <div [innerHTML]="pqrResult.description" class="rich-text-content"></div>
          </div>
          <div class="col-12 mb-3" *ngIf="pqrResult.response">
            <strong>Respuesta:</strong>
            <div [innerHTML]="pqrResult.response" class="rich-text-content"></div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
